var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".flag-a,.flag-d{fill:none;}.flag-a{stroke-width:2px;}.flag-b{fill:#fff;stroke-width:0.5px;}.flag-c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1114 -314)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "flag-a",
    transform: "translate(1114 314)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "flag-c",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "flag-d",
    cx: 17.5,
    cy: 17.5,
    r: 16.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "flag-b",
    d: "M23.517,5.211A.422.422,0,0,0,23.1,5.2l-.348.192a4.925,4.925,0,0,1-2.416.6,13.884,13.884,0,0,1-3.556-.659l-.018,0a14.952,14.952,0,0,0-3.885-.7,6.412,6.412,0,0,0-1.716.223,1.371,1.371,0,1,0-1.685.293v14.7a.422.422,0,0,0,.422.422h.474a.422.422,0,0,0,.422-.422V14.237a4.983,4.983,0,0,1,2.078-.433,13.883,13.883,0,0,1,3.556.659l.019.005a14.957,14.957,0,0,0,3.884.7,6.22,6.22,0,0,0,3.054-.76l.123-.067a.421.421,0,0,0,.219-.37V5.574A.421.421,0,0,0,23.517,5.211ZM10.8,6.382a4.907,4.907,0,0,1,2.074-.429,13.9,13.9,0,0,1,3.559.66l.017,0a14.955,14.955,0,0,0,3.884.7,6.205,6.205,0,0,0,2.078-.337v6.438a4.886,4.886,0,0,1-2.074.429,13.9,13.9,0,0,1-3.559-.66l-.016,0a15.051,15.051,0,0,0-3.946-.7,6.29,6.29,0,0,0-2.017.335Z",
    transform: "translate(1115.239 320.425)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.1b648ed640174bdb04be8d9626fd9175.svg";
export { ForwardRef as ReactComponent };